var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel granary-panel" }, [
    _c(
      "div",
      { staticClass: "content-box" },
      _vm._l(_vm.scList, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "list-item flex",
            class: { active: _vm.active === index },
            on: {
              click: function ($event) {
                return _vm.changeType(index)
              },
            },
          },
          [
            _c("div", [
              _c("div", { staticClass: "name" }, [_vm._v(_vm._s(item.name))]),
              _c("div", { staticClass: "total-box hybl-bg" }, [
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
                _c("span", { staticClass: "unit" }, [
                  _vm._v(_vm._s(item.unit)),
                ]),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
    _c("div", { staticClass: "chart-box" }, [
      _c("div", { ref: "scpChart", staticClass: "chart" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }